import { formatDate, getCurrentDate } from "@taabl/common-lib/calculators/date";
import { formatCurrency } from "@taabl/common-lib/calculators/money";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Constants } from "../../libs/Constants";
import PayLoanButton from "./PayLoanButton";

const RepayLoanButton = ({
  closingPeriodDetails,
  userObj,
  loanAmount,
  refresh,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="primary">
        Repay Loan
      </Button>
      <Modal
        show={open && closingPeriodDetails}
        onHide={() => setOpen(false)}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Repayment of Loan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Congratulations! You’ve earned{" "}
          <b>{formatCurrency(closingPeriodDetails?.periodProfit)}</b> from your
          ESPP through Taabl. You can now sell the excess stock to re-pay the
          taabl lending amount of <b>{formatCurrency(loanAmount)}</b>. This
          amount is due on{" "}
          <b>
            {formatDate(
              closingPeriodDetails?.repayDate,
              Constants.DATEFORMAT.MMDDYYYY
            )}
          </b>
          .
        </Modal.Body>
        <Modal.Footer>
          <PayLoanButton
            onPay={() => setOpen(false)}
            userObj={userObj}
            closingPeriodDetails={closingPeriodDetails}
            loanAmount={loanAmount}
            refresh={refresh}
          />
          {getCurrentDate() <= closingPeriodDetails?.repayDate.valueOf() && (
            <Button
              onClick={() => {
                setOpen(false);
              }}
              variant="outline-cancel"
            >
              Cancel
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RepayLoanButton;
